import { Text } from '@mantine/core'

import * as Types from '../../declarations'
import Video from '../Video'
import SectionHeader from './components/SectionHeader'

interface Props {
	trip: Types.DB.Models.TripAttributes
}

const Videos = ({
	trip: {
		name,
		jsonData: { videos, trekOrClimb },
	},
}: Props) => {
	if (!videos) return <></>

	const isTrek = trekOrClimb === 'TREK'

	return (
		<div id="videos-wrapper" className="spacing-between-sections-above">
			<SectionHeader
				title={`${name} Videos `}
				section={Types.App.DataTypes.FeedbackSection.VIDEOS}
			/>
			<Text mb="xl">
				Get inspired by these incredible videos capturing the experience of
				climbing {name}. From route highlights to summit
				{isTrek ? 'trail' : 'summit'} views, these clips showcase the{' '}
				{isTrek ? 'treks' : 'mountain’s'} beauty and the challenges it presents.
				Have your own {name} video? We&apos;d love for you to share it with the
				community to inspire future {isTrek ? 'trekkers' : 'climbers'}.
			</Text>
			<div id="videos-items">
				{videos.map((video, vidKey) => (
					// <Video id={video} key={vidKey} width="100%" />
					<Video id={video} key={vidKey} title={`${name} video`} />
				))}
			</div>
		</div>
	)
}

export default Videos
